/**
 * RESPONSIBILITY: one question and its answer.
 *
 * The "What to Expect" pattern the requirements doc likes, and the thing a first-time
 * parent actually opens the Children page for.
 */
import { Row, Text, Paragraph, RenderOf } from '@framework/core/decorators';

@Row()
export class Faq {
  @Text({ label: 'Question', maxLength: 600 })
  question!: string;

  @Paragraph({ label: 'Answer', maxLength: 20000, rows: 4, markdown: true, allow: ['verse'] })
  answer!: string;

  @RenderOf('answer')
  answerHtml!: string;
}
